import { render, staticRenderFns } from "./StoreTag.vue?vue&type=template&id=2e6bd18e"
import script from "./StoreTag.vue?vue&type=script&lang=js"
export * from "./StoreTag.vue?vue&type=script&lang=js"
import style0 from "./StoreTag.vue?vue&type=style&index=0&id=2e6bd18e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports